var initializeTabsBlock = function(block){

	jQuery(".tab-menu > li:eq(0), .tab-content > ul.content > li:eq(0)", block).addClass("active").show();
	
	jQuery(".tab-menu > li", block).on('click', function(){
		
		var index = jQuery(this).index();
		
		changeTab(index, block);

	});
	
	jQuery("select", block).on('change', function(){
			
		var index = jQuery(this).prop('selectedIndex');
		
		changeTab(index, block);

	});

	jQuery('.navigation button', block).on('click', function() {
		
		var current = jQuery(this);
		var index = jQuery(".tab-menu li.active", block).index();
		var totalTabs = jQuery(".tab-menu li", block).length;
		var nextTabIndex = 0;

		if(current.hasClass('next')) {
			nextTabIndex = (index < (totalTabs - 1)) ? index+1 : 0;
		} else {
			nextTabIndex = (index > 0) ? index-1 : (totalTabs - 1);
		}

		changeTab(nextTabIndex, block);
		
	});
	
	jQuery(".sub-tab-menu > li:first-child, .sub-tab-content > ul.content > li:first-child", block).addClass("active").show();
		
	jQuery(".sub-tab-menu > li", block).on('click', function(){
		
		var index = jQuery(this).index();
		var parent = jQuery(this).parents('.sub-tabs');

		changeSubTab(index, parent);

	});
	
	jQuery('.slick', block).each(function(){
		
		var current = jQuery(this);
		var carouselCount = jQuery('> .image', current).length;
		
		current.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			rows: 1,
			slidesPerRow: 1,
			dots: carouselCount > 1 ? true : false,
			arrows: false,
			autoplay: false,
			autoplaySpeed: 3000,
			fade: true,
			easing: "linear",
			pauseOnHover: false,
			infinite: true,
			draggable: false,
			swipe: true,
			adaptiveHeight: false
		});
		
	});

	if (typeof getUrlVars === "function") { 
	
		var urlTab = getUrlVars()['tab'];
			
		if(urlTab) {
			
			changeTab(parseInt(urlTab), block);
			
			jQuery('html, body').animate({scrollTop: block.offset().top}, 'slow');
			
		}
		
	}

}

//initialize each block on front end
jQuery(document).ready(function(){
	jQuery('.wp-block-tabs').each(function(){
		initializeTabsBlock(jQuery(this));
	});
});

//initialize dynamic block preview in the editor
if(window.acf)
	window.acf.addAction('render_block_preview/type=tabs', initializeTabsBlock);


function changeTab(index, block) {
	
	jQuery(".tab-menu li.active", block).removeClass("active");
	jQuery(".tab-menu li:eq(" + index + ")", block).addClass("active");
	
	jQuery("select", block).prop('selectedIndex', index);

	jQuery(".tab-content > ul.content > li.active", block).removeClass("active").hide();
	jQuery(".tab-content > ul.content > li:eq("+index+")", block).addClass("active").show();
	
	jQuery(".tab-content > ul.content > li.active div.slick", block).slick("getSlick").refresh();
	
}

function changeSubTab(index, parent) {
	
	jQuery(".sub-tab-menu li.active", parent).removeClass("active");
	jQuery(".sub-tab-menu li:eq(" + index + ")", parent).addClass("active");

	jQuery(".sub-tab-content > ul.content > li.active", parent).removeClass("active").hide();
	jQuery(".sub-tab-content > ul.content > li:eq("+index+")", parent).addClass("active").show();
	
	var container = parent.parents('.columns-6-6');
	var slick = jQuery('.slick', container);
	
	slick.slick("slickGoTo", index);
	
}